import { useTu } from "@src/appV2/i18n/useTu";

import { ContactPopoverButton } from "./ContactPopoverButton";

export function ContactSupportButton() {
  const { tu } = useTu("navigation");

  return (
    <ContactPopoverButton
      triggerLabel={tu("Contact Support")}
      triggerStartIconType="phone"
      dialogTitle={tu("Contact Support")}
      showHelpCenterSection={false}
    />
  );
}
